import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "font-semibold text-xl text-black-lp-100 border-b border-gray-lp-1300 w-full py-2.5 px-8 font-montserrat flex items-center justify-between" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  id: "booking-v4-form-main-column",
  "data-testid": "booking-v4-form-main-column",
  class: "flex-1 min-w-0 flex flex-col gap-y-2"
}
const _hoisted_4 = { class: "flex items-stretch gap-x-3" }
const _hoisted_5 = {
  id: "booking-v4-section-sender",
  class: "flex-shrink-0 min-w-0",
  style: {"flex-basis":"38%"}
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", {
  class: "flex flex-col items-center justify-between py-1.5 flex-none",
  style: {"gap":"4px"}
}, [
  /*#__PURE__*/_createVNode("span", { class: "flex-shrink-0 w-3 h-3 rounded-full bg-gray-lp-1300" }),
  /*#__PURE__*/_createVNode("div", { class: "flex-1 border-l-2 border-dashed border-gray-lp-1300" }),
  /*#__PURE__*/_createVNode("span", { class: "flex-shrink-0 w-3 h-3 rounded-full bg-gray-lp-1300" })
], -1)
const _hoisted_7 = {
  id: "booking-v4-section-receiver",
  class: "flex-1 min-w-0"
}
const _hoisted_8 = { id: "booking-v4-section-reference-number" }
const _hoisted_9 = { class: "flex flex-col gap-y-1 text-sm" }
const _hoisted_10 = { class: "font-semibold text-black-lp-100" }
const _hoisted_11 = { class: "text-black-lp-800 text-xs line-clamp-2" }
const _hoisted_12 = {
  id: "booking-v4-section-product-type",
  class: "mb-2"
}
const _hoisted_13 = {
  key: 0,
  id: "booking-v4-sticky-sidebar",
  "data-testid": "booking-v4-sticky-sidebar",
  class: "shrink-0 sticky top-0",
  style: {"width":"350px"}
}
const _hoisted_14 = { class: "p-3 border-b border-gray-lp-1600 flex flex-row items-center justify-between" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "text-xs font-semibold text-black-lp-100" }, " Cetak Resi ", -1)
const _hoisted_16 = { class: "relative inline-block" }
const _hoisted_17 = {
  key: 0,
  class: "absolute mt-2 right-0 z-40 py-2 bg-white rounded-xl shadow-md border border-gray-lp-1600",
  style: {"width":"180px"}
}
const _hoisted_18 = { class: "p-3" }
const _hoisted_19 = {
  "data-testid": "booking-modal-payment-method-container",
  class: "p-3 flex flex-col gap-y-2 border-t border-gray-lp-1600"
}
const _hoisted_20 = {
  key: 0,
  "data-testid": "booking-v4-error-limit-tagihan-insufficient",
  class: "text-xs text-red-lp-1200 mt-1"
}
const _hoisted_21 = { class: "border-t border-gray-lp-1600  flex flex-col gap-y-2 p-3" }
const _hoisted_22 = {
  key: 1,
  class: "shrink-0 sticky top-0",
  style: {"width":"350px"},
  "data-testid": "booking-v4-sticky-sidebar-loading"
}
const _hoisted_23 = { class: "p-3 border-b border-gray-lp-1600 flex items-center justify-between" }
const _hoisted_24 = { class: "p-3 flex flex-col gap-y-3" }
const _hoisted_25 = { class: "p-3 flex flex-col gap-y-3 border-t border-gray-lp-1600" }
const _hoisted_26 = { class: "border-t border-gray-lp-1600 flex flex-col gap-y-3 p-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_SenderSectionV4 = _resolveComponent("SenderSectionV4")!
  const _component_ReceiverSectionV4 = _resolveComponent("ReceiverSectionV4")!
  const _component_BookingSdnBanner = _resolveComponent("BookingSdnBanner")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ReferenceNumberV4 = _resolveComponent("ReferenceNumberV4")!
  const _component_card = _resolveComponent("card")!
  const _component_GoodsPackageV4 = _resolveComponent("GoodsPackageV4")!
  const _component_AdjustWeightSection = _resolveComponent("AdjustWeightSection")!
  const _component_SupportingDocSectionV4 = _resolveComponent("SupportingDocSectionV4")!
  const _component_ProductCardListV4 = _resolveComponent("ProductCardListV4")!
  const _component_FormCompletionPanel = _resolveComponent("FormCompletionPanel")!
  const _component_PaymentMethodSelectorV4 = _resolveComponent("PaymentMethodSelectorV4")!
  const _component_ProtectionPackingSummary = _resolveComponent("ProtectionPackingSummary")!
  const _component_TotalTarifSectionV4 = _resolveComponent("TotalTarifSectionV4")!
  const _component_BookingStickyFooterV4 = _resolveComponent("BookingStickyFooterV4")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Modal = _resolveComponent("Modal")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.visible = $event)),
      header: false,
      persistent: "",
      customBody: "p-0",
      showOverflow: "",
      customHeight: "calc(80vh / var(--viewport-scale)) !important",
      contentId: "modal-shipment-v4-parent",
      id: "modal-shipment-v4-parent"
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          (_ctx.loadingForm)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                width: "35%",
                height: "1.8rem"
              }))
            : (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.shipmentDetail.shipmentId || _ctx.shipmentDetail.shipmentAlgoId), 1)),
          _createVNode(_component_Icons, {
            name: "close",
            class: "w-5 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = () => (_ctx.visible = false))
          })
        ])
      ]),
      default: _withCtx(() => [
        (_openBlock(), _createBlock("div", {
          key: _ctx.selectedIndex,
          "data-testid": "booking-v3-modal-shipment-container",
          class: "flex flex-row items-start gap-3 p-3 bg-gray-lp-1200 font-montserrat",
          style: {"width":"calc(80vw / var(--viewport-scale)) !important"},
          tabindex: "0"
        }, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Card, {
              rounded: "xl",
              class: "flex flex-col p-4"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_4, [
                  _createVNode("div", _hoisted_5, [
                    _createVNode(_component_SenderSectionV4, {
                      modelValue: _ctx.bookingFormV4,
                      "onUpdate:modelValue": _ctx.onSenderUpdate,
                      errors: _ctx.errors,
                      "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errors = $event)),
                      currentIndex: _ctx.currentIndex,
                      "onUpdate:currentIndex": _ctx.onSectionCurrentIndexUpdate,
                      senderCountryIndex: _ctx.senderCountryIndex,
                      senderNameIndex: _ctx.senderNameIndex,
                      senderPhoneIndex: _ctx.senderPhoneIndex,
                      senderAddressIndex: _ctx.senderAddressIndex,
                      activeTab: _ctx.activeTab,
                      configName: _ctx.configRule.senderName,
                      configPhone: _ctx.configRule.senderPhone,
                      configAddress: _ctx.configRule.senderAddress,
                      configDistrict: _ctx.configRule.senderDistrict,
                      class: "mb-2",
                      onAutofillCommodity: _ctx.onAutofillCommodity,
                      onValidationChange: _ctx.onSenderValidationChange
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "currentIndex", "onUpdate:currentIndex", "senderCountryIndex", "senderNameIndex", "senderPhoneIndex", "senderAddressIndex", "activeTab", "configName", "configPhone", "configAddress", "configDistrict", "onAutofillCommodity", "onValidationChange"])
                  ]),
                  _hoisted_6,
                  _createVNode("div", _hoisted_7, [
                    _createVNode(_component_ReceiverSectionV4, {
                      modelValue: _ctx.bookingFormV4,
                      "onUpdate:modelValue": _ctx.onReceiverUpdate,
                      errors: _ctx.errors,
                      "onUpdate:errors": _cache[3] || (_cache[3] = ($event: any) => (_ctx.errors = $event)),
                      currentIndex: _ctx.currentIndex,
                      "onUpdate:currentIndex": _ctx.onSectionCurrentIndexUpdate,
                      receiverCountryIndex: _ctx.receiverCountryIndex,
                      receiverNameIndex: _ctx.receiverNameIndex,
                      receiverPhoneIndex: _ctx.receiverPhoneIndex,
                      receiverAddressIndex: _ctx.receiverAddressIndex,
                      receiverDistrictIndex: _ctx.receiverDistrictIndex,
                      receiverPostalCodeIndex: _ctx.receiverPostalCodeIndex,
                      activeTab: _ctx.activeTab,
                      isForeign: _ctx.isAccountForeignPos,
                      isErrorEmbargo: _ctx.isErrorEmbargoDestination,
                      isErrorRouteNotFound: _ctx.errorRouteNotFound,
                      "onUpdate:isErrorRouteNotFound": _cache[4] || (_cache[4] = ($event: any) => (_ctx.errorRouteNotFound = $event)),
                      configName: _ctx.configRule.recipientName,
                      configPhone: _ctx.configRule.recipientPhone,
                      configAddress: _ctx.configRule.recipientAddress,
                      configDistrict: _ctx.configRule.recipientDistrict,
                      configPostalCode: _ctx.configRule.recipientPostalCode,
                      configCountry: _ctx.configRule.recipientDistrict,
                      preserveDistrictOnPostalClear: "",
                      syncLocationOnClear: "",
                      isPostalCodeRequired: false,
                      class: "mb-2",
                      onValidationChange: _ctx.onReceiverValidationChange,
                      excludeCountryMatch: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "currentIndex", "onUpdate:currentIndex", "receiverCountryIndex", "receiverNameIndex", "receiverPhoneIndex", "receiverAddressIndex", "receiverDistrictIndex", "receiverPostalCodeIndex", "activeTab", "isForeign", "isErrorEmbargo", "isErrorRouteNotFound", "configName", "configPhone", "configAddress", "configDistrict", "configPostalCode", "configCountry", "onValidationChange"])
                  ])
                ]),
                _createVNode(_component_BookingSdnBanner, {
                  originDistrict: _ctx.districtDetail,
                  destinationDistrict: _ctx.bookingFormV4.receiver.destinationCity,
                  active: _ctx.visible && !_ctx.loadingForm
                }, null, 8, ["originDistrict", "destinationDistrict", "active"])
              ]),
              _: 1
            }),
            _createVNode(_component_Card, {
              rounded: "xl",
              class: "flex items-stretch p-4"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_ReferenceNumberV4, {
                    modelValue: _ctx.bookingFormV4.references,
                    "onUpdate:modelValue": _ctx.onReferencesUpdate,
                    errors: _ctx.errors,
                    "onUpdate:errors": _cache[5] || (_cache[5] = ($event: any) => (_ctx.errors = $event)),
                    formContext: "retail",
                    accountType: _ctx.accountType,
                    isRequired: _ctx.isReferenceRequired,
                    maxItems: 10,
                    configManualSttNo: _ctx.configRule.manualSttNo,
                    configSttNoRefExternal: _ctx.configRule.sttNoRefExternal,
                    onValidationChange: _ctx.onReferenceValidationChange,
                    onFocusin: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onSectionCurrentIndexUpdate(9)))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "errors", "accountType", "isRequired", "configManualSttNo", "configSttNoRefExternal", "onValidationChange"])
                ])
              ]),
              _: 1
            }),
            (_ctx.displayGoodsName)
              ? (_openBlock(), _createBlock(_component_card, {
                  key: 0,
                  class: "p-4 bg-white",
                  rounded: "xl",
                  isShadow: false
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_9, [
                      _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("bookingV4.shipment.goodsName.title")), 1),
                      _createVNode("div", _hoisted_11, _toDisplayString(_ctx.goodsName), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_Card, {
              rounded: "xl",
              class: ""
            }, {
              default: _withCtx(() => [
                _createVNode("div", {
                  id: "booking-v4-section-goods-pieces",
                  class: "p-4",
                  onFocusin: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onSectionCurrentIndexUpdate(11)))
                }, [
                  (!_ctx.loadingForm && _ctx.bookingFormV4.shipmentId)
                    ? (_openBlock(), _createBlock(_component_GoodsPackageV4, {
                        key: 0,
                        ref: "goodsPackageRef",
                        modelValue: _ctx.bookingFormV4,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.bookingFormV4 = $event)),
                        showItemDetails: _ctx.showItemDetails,
                        showSavePackageCheckbox: false,
                        isFtz: _ctx.isFtzForm,
                        localCurrency: _ctx.formAccountCurrencyCode,
                        currencyPrefix: _ctx.formAccountCurrencyPrefix,
                        numericLocale: _ctx.formAccountNumericLocale,
                        isForeign: _ctx.isDestinationForeign,
                        commodityCipl: _ctx.bookingFormV4.commodityCipl,
                        ciplCommodities: _ctx.ciplCommodityOptions,
                        estimatedConversion: _ctx.ciplEstimatedConversion,
                        deminimisThreshold: _ctx.ciplDeminimisThreshold,
                        deminimisExceeded: _ctx.ciplDeminimisExceeded,
                        recipientImportDocRequired: _ctx.recipientImportDocRequired,
                        selfClearanceRequired: _ctx.selfClearanceRequired,
                        destinationCurrencyCode: _ctx.dutyTaxDestinationCurrency,
                        commodity: _ctx.bookingFormV4.commodity,
                        commodities: _ctx.commoditySearchResults,
                        recommendedCommodities: _ctx.commodityRecommendations,
                        errors: _ctx.errors,
                        loading: _ctx.commodityListLoading,
                        hasMore: _ctx.commodityListHasMore,
                        modalSearchResults: _ctx.modalSearchResults,
                        commodityCategories: _ctx.commodityCategories,
                        commodityCategoryItems: _ctx.commodityCategoryItems,
                        selectedCategoryCode: _ctx.selectedCategoryCode,
                        modalLoading: _ctx.commodityModalLoading,
                        modalLoadingCategory: _ctx.commodityModalLoadingCategory,
                        modalHasMore: _ctx.commodityModalHasMore,
                        pieces: _ctx.bookingFormV4.pieces,
                        volumeWeightDivisor: _ctx.volumeWeightDivisorForSelectedProduct,
                        hwsConfig: _ctx.hwsConfigForSelectedProduct,
                        maxPieces: _ctx.maxGoodsPieces,
                        singlePieceOnly: _ctx.receiverSinglePieceOnly,
                        configCommodity: _ctx.configRule.commodity,
                        configGoodsPrice: _ctx.configRule.goodsPrice,
                        configGrossWeight: _ctx.configRule.grossWeight,
                        configDimension: _ctx.configRule.dimension,
                        configAdjustPieceAdd: _ctx.configRule.adjustPiece,
                        configAdjustPieceRemove: _ctx.configRule.adjustPiece,
                        configCipl: 
                _ctx.isFtzForm ? _ctx.configRule.ftzCipl : _ctx.configRule.interCipl
              ,
                        isEdit: true,
                        disabledWeightAdjustment: _ctx.disabledPiece.adjustmentWeight,
                        minWeightThreshold: _ctx.shipmentDetail.shipmentChargeableWeight,
                        isShowSectionUpload: !_ctx.isB1APAS,
                        isMaxChWeight: _ctx.isMaxChWeightTokopedia,
                        preventDecreasedWeight: _ctx.preventDecreasedWeight,
                        isItemDetailsRequired: false,
                        "onUpdate:commodityCipl": _ctx.onCommodityCiplUpdate,
                        "onUpdate:commodity": _ctx.onCommodityUpdate,
                        "onUpdate:pieces": _ctx.onPiecesUpdate,
                        onReset: _ctx.onGoodsPackageReset,
                        onCiplValidationChange: _ctx.onCiplValidationChange,
                        onCommodityValidationChange: _ctx.onCommodityValidationChange,
                        onPackageWeightValidationChange: _ctx.onPackageWeightValidationChange,
                        onSearchCommodity: _ctx.searchCommodity,
                        onLoadMoreCommodities: _ctx.loadMoreCommodities,
                        onSearchCommodityModal: _ctx.searchCommodityModal,
                        onLoadMoreCommodityModal: _ctx.loadMoreCommodityModal,
                        onSelectCommodityCategory: _ctx.selectCommodityCategory,
                        onCommodityError: _ctx.onCommodityError,
                        eligibleEditSize: _ctx.eligibleEditSize
                      }, null, 8, ["modelValue", "showItemDetails", "isFtz", "localCurrency", "currencyPrefix", "numericLocale", "isForeign", "commodityCipl", "ciplCommodities", "estimatedConversion", "deminimisThreshold", "deminimisExceeded", "recipientImportDocRequired", "selfClearanceRequired", "destinationCurrencyCode", "commodity", "commodities", "recommendedCommodities", "errors", "loading", "hasMore", "modalSearchResults", "commodityCategories", "commodityCategoryItems", "selectedCategoryCode", "modalLoading", "modalLoadingCategory", "modalHasMore", "pieces", "volumeWeightDivisor", "hwsConfig", "maxPieces", "singlePieceOnly", "configCommodity", "configGoodsPrice", "configGrossWeight", "configDimension", "configAdjustPieceAdd", "configAdjustPieceRemove", "configCipl", "disabledWeightAdjustment", "minWeightThreshold", "isShowSectionUpload", "isMaxChWeight", "preventDecreasedWeight", "onUpdate:commodityCipl", "onUpdate:commodity", "onUpdate:pieces", "onReset", "onCiplValidationChange", "onCommodityValidationChange", "onPackageWeightValidationChange", "onSearchCommodity", "onLoadMoreCommodities", "onSearchCommodityModal", "onLoadMoreCommodityModal", "onSelectCommodityCategory", "onCommodityError", "eligibleEditSize"]))
                    : _createCommentVNode("", true)
                ], 32)
              ]),
              _: 1
            }),
            (!_ctx.isB1APAS)
              ? (_openBlock(), _createBlock(_component_AdjustWeightSection, {
                  key: 1,
                  showViewAdjustment: _ctx.openAdjustmentWeight,
                  "onUpdate:showViewAdjustment": _cache[9] || (_cache[9] = ($event: any) => (_ctx.openAdjustmentWeight = $event)),
                  modelValue: _ctx.bookingFormV4.adjustmentWeightAttachments,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.bookingFormV4.adjustmentWeightAttachments = $event)),
                  onShowViewAdjustment: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openAdjustmentWeight = !_ctx.openAdjustmentWeight)),
                  watermark: _ctx.shipmentDetail.shipmentId,
                  isMandatoryUploadProofAdjust: _ctx.isMandatoryUploadProofAdjust
                }, null, 8, ["showViewAdjustment", "modelValue", "watermark", "isMandatoryUploadProofAdjust"]))
              : _createCommentVNode("", true),
            (_ctx.showSupportingDocSection)
              ? (_openBlock(), _createBlock(_component_SupportingDocSectionV4, {
                  key: 2,
                  modelValue: _ctx.bookingFormV4.supportingDoc,
                  isFtz: _ctx.isFtzForm,
                  isCipl: _ctx.isCipl,
                  fieldRules: _ctx.supportingDocFieldRules,
                  showRequiredImageErrors: _ctx.hasAttemptedSubmit,
                  errors: _ctx.errors,
                  configRules: _ctx.supportingDocAdjustRules,
                  "onUpdate:modelValue": _ctx.onSupportingDocUpdate,
                  onValidationChange: _ctx.onSupportingDocValidationChange,
                  onFocusin: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onSectionCurrentIndexUpdate(20))),
                  isRetail: ""
                }, null, 8, ["modelValue", "isFtz", "isCipl", "fieldRules", "showRequiredImageErrors", "errors", "configRules", "onUpdate:modelValue", "onValidationChange"]))
              : _createCommentVNode("", true),
            _createVNode(_component_Card, {
              rounded: "xl",
              class: ""
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_ProductCardListV4, {
                    modelValue: _ctx.bookingFormV4.product.productType,
                    "onUpdate:modelValue": [
                      _cache[13] || (_cache[13] = ($event: any) => (_ctx.bookingFormV4.product.productType = $event)),
                      _ctx.onProductTypeSelect
                    ],
                    products: _ctx.productCardItems,
                    showAgentDiscountToggle: false,
                    agentDiscountRevealed: _ctx.isAgentDiscountRevealed,
                    agentDiscountToggleEnabled: _ctx.isSuperAdminBooking,
                    loading: _ctx.productUpsellingLoading,
                    isError: _ctx.productUpsellingIsError,
                    currencyPrefix: _ctx.formCurrencyPrefix,
                    configTariff: _ctx.configRule.tariff,
                    isClient: false,
                    "onUpdate:agentDiscountRevealed": _ctx.onAgentDiscountRevealedUpdate,
                    onRetry: _ctx.onProductUpsellingRetry
                  }, null, 8, ["modelValue", "products", "agentDiscountRevealed", "agentDiscountToggleEnabled", "loading", "isError", "currencyPrefix", "configTariff", "onUpdate:modelValue", "onUpdate:agentDiscountRevealed", "onRetry"])
                ])
              ]),
              _: 1
            })
          ]),
          (_ctx.bookingFormV4.shipmentId && !_ctx.loadingForm)
            ? (_openBlock(), _createBlock("aside", _hoisted_13, [
                _createVNode(_component_Card, {
                  rounded: "xl",
                  class: "flex flex-col gap-y-2 items-stretch "
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _withDirectives(_createVNode("div", _hoisted_16, [
                        _createVNode("button", {
                          "data-testid": "booking-v4-header-receipt-format-selector",
                          class: "flex items-center gap-2 rounded-full h-8 px-3 text-xs font-semibold text-black-lp-100 border border-gray-lp-1600",
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.toggleReceiptFormatMenu && _ctx.toggleReceiptFormatMenu(...args)))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.activeReceiptFormatLabel) + " ", 1),
                          _createVNode(_component_Icons, {
                            name: "chevron-down",
                            class: "w-3"
                          })
                        ]),
                        (_ctx.showReceiptFormatMenu)
                          ? (_openBlock(), _createBlock("div", _hoisted_17, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.receiptFormatOptions, (option, index) => {
                                return (_openBlock(), _createBlock("button", {
                                  key: option.value,
                                  "data-testid": 
                    `booking-v4-header-receipt-format-option-${option.value}`
                  ,
                                  class: ["flex items-center w-full px-4 py-2 text-xs text-left gap-2.5", [
                    option.value === _ctx.receiptFormat
                      ? 'font-semibold text-red-lp-2400'
                      : 'text-black-lp-100',
                    {
                      'border-b border-gray-lp-1600':
                        index !== _ctx.receiptFormatOptions.length - 1
                    }
                  ]],
                                  onClick: ($event: any) => (_ctx.onReceiptFormatClick(option.value))
                                }, [
                                  _createVNode(_component_Icons, {
                                    name: "printer",
                                    class: ["w-6", [
                      { 'text-gray-lp-3005': option.value !== _ctx.receiptFormat }
                    ]]
                                  }, null, 8, ["class"]),
                                  _createTextVNode(" " + _toDisplayString(option.label), 1)
                                ], 10, ["data-testid", "onClick"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ], 512), [
                        [_directive_click_outside, _ctx.closeReceiptFormatMenu]
                      ])
                    ]),
                    _createVNode("div", _hoisted_18, [
                      _createVNode(_component_FormCompletionPanel, {
                        items: _ctx.formCompletionItems,
                        onNavigate: _ctx.onFormCompletionNavigate
                      }, null, 8, ["items", "onNavigate"])
                    ]),
                    _createVNode("div", _hoisted_19, [
                      _createVNode(_component_PaymentMethodSelectorV4, {
                        paymentMethod: _ctx.bookingFormV4.paymentMethod,
                        paymentMethodOptions: _ctx.paymentMethodOptions,
                        currencyPrefix: _ctx.formCurrencyPrefix,
                        readonly: _ctx.isShipment && !_ctx.isShipmentFavorite,
                        form: _ctx.bookingFormV4,
                        "onUpdate:paymentMethod": _ctx.onPaymentMethodUpdate
                      }, null, 8, ["paymentMethod", "paymentMethodOptions", "currencyPrefix", "readonly", "form", "onUpdate:paymentMethod"]),
                      (_ctx.isLimitTagihanInsufficient)
                        ? (_openBlock(), _createBlock("p", _hoisted_20, _toDisplayString(_ctx.$t("bookingV4.error.limitTagihanInsufficient")), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ProtectionPackingSummary, {
                        modelValue: _ctx.bookingFormV4,
                        protectionPacking: _ctx.bookingFormV4.protectionPacking,
                        paymentMethod: _ctx.bookingFormV4.paymentMethod,
                        currencyPrefix: _ctx.goodsPriceCurrencyPrefix,
                        numericLocale: _ctx.formNumericLocale,
                        isCrossCountryCod: _ctx.isCrossCountryCod,
                        agentDiscountCommission: _ctx.agentDiscountCommission,
                        itemPriceError: _ctx.errors.itemPrice,
                        insuranceBasic: _ctx.insuranceBasic,
                        isInsuranceVisible: true,
                        configInsurance: _ctx.configRule.insurance,
                        configCodAmount: _ctx.codAmountConfig,
                        configGoodsPrice: _ctx.configRule.goodsPrice,
                        configWoodpacking: _ctx.configRule.woodpacking,
                        isShowCODAmountField: "",
                        "onUpdate:protectionPacking": _ctx.onProtectionPackingUpdate,
                        "onUpdate:paymentMethod": _ctx.onPaymentMethodUpdate,
                        onBlurItemPrice: _ctx.onItemPriceBlur
                      }, null, 8, ["modelValue", "protectionPacking", "paymentMethod", "currencyPrefix", "numericLocale", "isCrossCountryCod", "agentDiscountCommission", "itemPriceError", "insuranceBasic", "configInsurance", "configCodAmount", "configGoodsPrice", "configWoodpacking", "onUpdate:protectionPacking", "onUpdate:paymentMethod", "onBlurItemPrice"])
                    ]),
                    _createVNode("div", _hoisted_21, [
                      _createVNode(_component_BookingStickyFooterV4, {
                        chargeableWeightKg: _ctx.footerChargeableWeightKg,
                        totalKoli: _ctx.bookingFormV4.protectionPacking.totalKoli,
                        chargeableWeightExpanded: 
                _ctx.bookingFormV4.protectionPacking.chargeableWeightExpanded
              ,
                        "onUpdate:chargeableWeightExpanded": _cache[15] || (_cache[15] = ($event: any) => (
                _ctx.bookingFormV4.protectionPacking.chargeableWeightExpanded
               = $event)),
                        chargeableWeightBreakdown: _ctx.chargeableWeightBreakdown,
                        woodpacking: _ctx.bookingFormV4.protectionPacking.woodpacking,
                        "onUpdate:protectionPacking": _ctx.onProtectionPackingUpdateFromCwFooter
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_TotalTarifSectionV4, {
                            modelValue: _ctx.bookingFormV4,
                            estimationPrice: _ctx.bookingFormV4.estimationPrice,
                            currencyPrefix: _ctx.goodsPriceCurrencyPrefix,
                            paymentMethod: _ctx.bookingFormV4.paymentMethod,
                            appliedVoucherCode: _ctx.bookingFormV4.voucher.appliedVoucherCode,
                            itemPrice: _ctx.bookingFormV4.protectionPacking.itemPrice,
                            woodpacking: _ctx.bookingFormV4.protectionPacking.woodpacking,
                            protectionChecked: 
                  _ctx.bookingFormV4.protectionPacking.protectionChecked
                ,
                            isFtz: _ctx.isFtz,
                            isLoading: _ctx.estimationLoading,
                            isError: _ctx.estimationIsError,
                            canOpenDetail: !_ctx.isPriceMasked,
                            isPriceMasked: _ctx.isPriceMasked,
                            isCrossCountryCod: _ctx.isCrossCountryCod,
                            onRefresh: _ctx.onTariffRefresh,
                            isRetail: "",
                            hideCodReturnFee: !_ctx.isCAPrefix
                          }, null, 8, ["modelValue", "estimationPrice", "currencyPrefix", "paymentMethod", "appliedVoucherCode", "itemPrice", "woodpacking", "protectionChecked", "isFtz", "isLoading", "isError", "canOpenDetail", "isPriceMasked", "isCrossCountryCod", "onRefresh", "hideCodReturnFee"])
                        ]),
                        _: 1
                      }, 8, ["chargeableWeightKg", "totalKoli", "chargeableWeightExpanded", "chargeableWeightBreakdown", "woodpacking", "onUpdate:protectionPacking"]),
                      _createVNode(_component_LpButton, {
                        class: "mt-4",
                        title: 
                _ctx.$t('bookingV4.footer.bookingAction') +
                  ` (${_ctx.selectedIndex + 1}/${_ctx.data.length})`
              ,
                        color: "red-lp-2400",
                        textColor: "white",
                        isWidthFull: "",
                        fontWeight: "semibold",
                        "data-testid": "booking-v4-submit",
                        tabAccessible: "",
                        onClick: _ctx.emitSubmit
                      }, {
                        suffix: _withCtx(() => [
                          _createVNode(_component_Icons, {
                            name: "arrow-up-medium",
                            class: "w-5 text-white",
                            style: {"transform":"rotate(90deg)"}
                          })
                        ]),
                        _: 1
                      }, 8, ["title", "onClick"]),
                      (_ctx.data.length && _ctx.selectedIndex < _ctx.data.length - 1)
                        ? (_openBlock(), _createBlock(_component_LpButton, {
                            key: 0,
                            class: "mt-4",
                            title: "Lewati",
                            color: "red-lp-100",
                            textColor: "red-lp-100",
                            outline: "",
                            isWidthFull: "",
                            fontWeight: "semibold",
                            "data-testid": "booking-v3-modal-shipment-button-skip",
                            tabAccessible: "",
                            onClick: _ctx.onSkipShipment
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock("aside", _hoisted_22, [
                _createVNode(_component_Card, {
                  rounded: "xl",
                  class: "flex flex-col gap-y-2 items-stretch"
                }, {
                  default: _withCtx(() => [
                    _createVNode("div", _hoisted_23, [
                      _createVNode(_component_Skeleton, {
                        width: "35%",
                        height: "1rem"
                      }),
                      _createVNode(_component_Skeleton, {
                        width: "7rem",
                        height: "2rem"
                      })
                    ]),
                    _createVNode("div", _hoisted_24, [
                      (_openBlock(), _createBlock(_Fragment, null, _renderList(4, (index) => {
                        return _createVNode(_component_Skeleton, {
                          key: index,
                          width: "100%",
                          height: "1rem"
                        })
                      }), 64))
                    ]),
                    _createVNode("div", _hoisted_25, [
                      _createVNode(_component_Skeleton, {
                        width: "45%",
                        height: "1rem"
                      }),
                      _createVNode(_component_Skeleton, {
                        width: "100%",
                        height: "2rem"
                      }),
                      _createVNode(_component_Skeleton, {
                        width: "70%",
                        height: "1rem"
                      })
                    ]),
                    _createVNode("div", _hoisted_26, [
                      _createVNode(_component_Skeleton, {
                        width: "55%",
                        height: "1.5rem"
                      }),
                      _createVNode(_component_Skeleton, {
                        width: "100%",
                        height: "2.5rem"
                      }),
                      _createVNode(_component_Skeleton, {
                        width: "100%",
                        height: "2.5rem"
                      })
                    ])
                  ]),
                  _: 1
                })
              ]))
        ]))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.confirmClose)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onSubmit: _ctx.onCloseForm,
          onClose: () => (_ctx.confirmClose = false),
          title: "Yakin ingin keluar?",
          message: "Perubahan data booking tidak akan tersimpan.",
          image: "badge-warning-lg",
          textSuccess: "Keluar",
          textCancel: "Tetap disini"
        }, null, 8, ["onSubmit", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}